var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.user)?_c('NavBar'):_vm._e(),_c('div',{staticClass:"router-view"},[_c('router-view')],1),(_vm.hasModal)?_c('div',{staticClass:"modal-background"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }